module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "salesCommission"
  }, [_c('div', {
    staticClass: "content"
  }, [_c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading.fullscreen",
      value: (_vm.loading),
      expression: "loading",
      modifiers: {
        "fullscreen": true
      }
    }],
    staticClass: "panel",
    attrs: {
      "element-loading-spinner": "el-icon-loading",
      "element-loading-background": "rgba(255, 255, 255, 0.5)"
    }
  }, [(_vm.trData) ? _c('mtable', {
    attrs: {
      "thData": _vm.thData,
      "trData": _vm.trData,
      "multiLanguage": _vm.multiLanguage,
      "selPage": _vm.selPage,
      "seekDropdown": _vm.seekDropdown,
      "page": _vm.page,
      "jsonExcelAjax": _vm.jsonExcelAjax,
      "handle": _vm.handle,
      "sort": _vm.sort,
      "isSetting": _vm.isSetting,
      "region": _vm.curArea,
      "label": _vm.label
    },
    on: {
      "seek": _vm.tableAjax,
      "tableChange": _vm.tableAjax
    }
  }) : _vm._e()], 1)])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-e29724ac","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/CommissionSetting2/Sale/SaleSetting/saleSettingView.vue
// module id = 1144
// module chunks = 1